export default __webpack_public_path__ + "static/media/CentraNo2-Medium.78b1a18f.woff2";